import axios from 'axios';

class AutenthicationService {
  state = {
    userid: '',
    password: '',
    token: '',
  };
  saveToken = (token) => {
    this.state.token = token;
    sessionStorage.setItem('token', token);
  };
  getToken = () => {
    let token = sessionStorage.getItem('token');
    //token=token+"clsadrt";
    return token;
  };
  saveUserInfo = (username, userid, idute) => {
    //sessionStorage.setItem('user', username);
    this.state.userid = userid;
    this.state.password = username;

    sessionStorage.setItem('user', userid);
    sessionStorage.setItem('idute', idute);
    this.setupAxiosInterceptors();
  };
  clearUserInfo = (username) => {
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('token');
    //sessionStorage.removeItem('userid');
  };
  getUserInfo = () => {
    return sessionStorage.getItem('user');
  };
  getIdUte = () => {
    return sessionStorage.getItem('idute');
  };

  isLogged = () => {
    console.log('sono dentro isLoged');
    debugger;
    let user = this.getUserInfo();

    if (user === null) {
      return false;
    } else {
      return true;
    }
  };
  setupAxiosInterceptors() {
    let BasicAuthHeader =
      'Basic ' + window.btoa(this.state.userid + ':' + this.state.password);

    axios.interceptors.request.use((config) => {
      if (this.isLogged) {
        config.headers.authorization = BasicAuthHeader;
      }
      return config;
    });
  }
}

export default new AutenthicationService();
